import apiClient from './apiClient';

export interface PetCategory {
  _id: string;
  name: string;
  slug: string;
  description?: string;
  image?: string;
  icon?: string;
  isActive: boolean;
  isBlocked?: boolean;
  blockReason?: string;
  blockedAt?: string;
  blockedBy?: string;
  breedCount?: number;
  createdAt: string;
  updatedAt: string;
}

class PetCategoriesService {
  async getCategories(includeInactive = false) {
    // includeInactive → isActive=all so the admin list shows disabled categories
    // too (otherwise a toggled-off category vanishes and can't be re-enabled).
    const response = await apiClient.get(`/pet-categories${includeInactive ? '?isActive=all' : ''}`);
    return response.data;
  }

  async getCategoryById(id: string) {
    const response = await apiClient.get(`/pet-categories/${id}`);
    return response.data;
  }

  async createCategory(data: Partial<PetCategory>) {
    const response = await apiClient.post('/pet-categories', data);
    return response.data;
  }

  async updateCategory(id: string, data: Partial<PetCategory>) {
    const response = await apiClient.put(`/pet-categories/${id}`, data);
    return response.data;
  }

  async toggleCategoryStatus(id: string) {
    const response = await apiClient.patch(`/pet-categories/${id}/toggle-status`);
    return response.data;
  }

  async deleteCategory(id: string) {
    const response = await apiClient.delete(`/pet-categories/${id}`);
    return response.data;
  }

  async toggleCategoryBlock(id: string, blockReason?: string) {
    const response = await apiClient.patch(`/pet-categories/${id}/toggle-block`, { blockReason });
    return response.data;
  }
}

export const petCategoriesService = new PetCategoriesService();
export default petCategoriesService;

